var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row row-middle row-full row-collapse"},[_c('div',{staticClass:"columns ps--r"},[_c('featured-memberships',{attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }